<ng-container *ngIf="user?.fonction !== TypeProfil.COLLABORATEUR">
    &nbsp; <mat-icon [matTooltip]="'ndf.generalites.proprietaire' | translate">person_outline</mat-icon> 
    &nbsp; {{ proprietaireUser | user }}
</ng-container>
